import { render, staticRenderFns } from "./ArticleHotTravelContainer.vue?vue&type=template&id=7894ddbe&"
import script from "./ArticleHotTravelContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleHotTravelContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports